export const environment = {
   production: false,
   API_URL: 'https://backend.dev.map.cevi.tools//',
   VALHALLA_URL: 'https://valhalla.dev.map.cevi.tools/',
   DOCS_URL: 'http://docs.dev.map.cevi.tools/',
};
